var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5188 16.17L5.58109 19.7318C5.33643 19.9209 5.06953 20.01 4.78039 19.9991C4.49124 19.989 4.23546 19.9104 4.01305 19.7633C3.79063 19.6162 3.61848 19.4166 3.49659 19.1644C3.37382 18.9123 3.36804 18.6391 3.47924 18.3449L5.38091 12.5136L0.543334 9.26702C0.276433 9.09891 0.10962 8.87826 0.0428948 8.60509C-0.0238305 8.33191 -0.0127095 8.07975 0.0762575 7.8486C0.165225 7.61745 0.320917 7.41235 0.543334 7.23332C0.765752 7.05512 1.03265 6.96602 1.34404 6.96602H7.31595L9.25098 0.914093C9.36219 0.619902 9.53478 0.393796 9.76877 0.235773C10.0019 0.0785914 10.2519 0 10.5188 0C10.7857 0 11.0357 0.0785914 11.2688 0.235773C11.5027 0.393796 11.6753 0.619902 11.7865 0.914093L13.7216 6.96602H19.6935C20.0049 6.96602 20.2718 7.05512 20.4942 7.23332C20.7166 7.41235 20.8723 7.61745 20.9613 7.8486C21.0502 8.07975 21.0613 8.33191 20.9946 8.60509C20.9279 8.87826 20.7611 9.09891 20.4942 9.26702L15.6566 12.5136L17.5583 18.3449C17.6695 18.6391 17.6641 18.9123 17.5423 19.1644C17.4195 19.4166 17.2469 19.6162 17.0245 19.7633C16.8021 19.9104 16.5463 19.989 16.2571 19.9991C15.968 20.01 15.7011 19.9209 15.4564 19.7318L10.5188 16.17Z",
    fill: "#FFCB05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.aa3da5d87b2b4c2f5631b4be806b3450.svg";
export { ForwardRef as ReactComponent };